import dayjs from "dayjs";

import { FailedAchContributionQuery, FailedAchContributionQueryVariables } from "@ctypes";
import { DateFormat } from "@ctypes/date";
import { FAILED_ACH_CONTRIBUTION } from "@graphql";
import { useQuery } from "@hooks/apollo";
import { convertCentsToDollar, formatCurrency } from "@utils/formatter";

type UseFailedAchContributionOptions = {
  skip?: boolean;
};

export const useFailedAchContribution = ({ skip }: UseFailedAchContributionOptions = {}) => {
  const { data: queryData, ...rest } = useQuery<
    FailedAchContributionQuery,
    FailedAchContributionQueryVariables
  >(FAILED_ACH_CONTRIBUTION, { skip });

  const data = queryData?.failedAchContribution;
  const failedTransaction = data?.failedTransaction;

  const amountInCents = failedTransaction?.amountInCents;
  const amount = amountInCents != null ? formatCurrency(convertCentsToDollar(amountInCents)) : "";
  const dateRaw = failedTransaction?.scheduledDate ?? failedTransaction?.date;
  const date = dateRaw ? dayjs(dateRaw).format(DateFormat.FullDate) : "";

  const contributionFailedSubtitle = {
    amount,
    date,
    hasSubtitle: Boolean(amount && date),
  };

  return {
    data,
    failedTransaction,
    contributionFailedSubtitle,
    ...rest,
  };
};
